import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const style = {
  margin: 0,
  padding: 0,
  minHeight: "100vh",
  minWidth: "100vw",
  position: "fixed",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  left: 0,
  top: 0,
  zIndex: 100,
  backgroundColor: "rgba(0,0,0,0.4)",
};

const Loading = () => {
  return (
    <div style={style}>
      <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: "#00AFEE" }} spin />} />
    </div>
  );
};

export default Loading;
